/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Description from "App/model/description";
import Annotation from "App/model/annotations/annotation";
import IElement from "js_interface/src/elements/element_interface";

export default
class Annotations {

    protected _modelDescription: Description;
    protected _annotations: any = {};

    constructor(aModelDescription: Description) {
        this._modelDescription = aModelDescription;
    }

    public parse(aModelDescriptionJSON: any): boolean {
        if (!aModelDescriptionJSON.hasOwnProperty("Annotations")) {
            return false;
        }

        let annotationsJSON = aModelDescriptionJSON.Annotations;

        // pass through all annotations
        for (let i = 0; i < annotationsJSON.length; i++) {
            let annotation = new Annotation(this);
            annotation.parse(annotationsJSON[i]);
            this._annotations[annotation.getParsedUID()] = annotation;
        }

        return true;
    }

    public getModelDescription(): Description {
        return this._modelDescription;
    }

    public getAnnotationByUID(aUID: number): Annotation {
        return this._annotations[aUID];
    }

    public getAnnotationConstructionGroups(): number[] {
        let annotationsID:number[] = [];

        for (let a in this._annotations) {
            let data = this._annotations[a]._data.data;
            let x = JSON.parse(data);
            if(!annotationsID.includes(x["#1007"])){
                annotationsID.push(x["#1007"]);
            }
        }
        return annotationsID;
    }

    public getAnnotations(aFilter: any): number[] {
        //      "type": "Metadata", "UID": 222 , "data": "{\"#1000\":\"Arêtier\",\"#1001\":\"\",\"#1002\":\"\",\"#1007\":\"\",\"#1008\":\"0\",\"DirX\":1,\"DirY\":0,\"DirZ\":0,\"Enable\":false,\"Meta Data\":[],\"PosX\":6.936121463775635,\"PosY\":3.6889665126800537,\"PosZ\":3.085501194000244,\"Text\":\"\"}"
        let result: number[] = [];
        let rexp = null;
        for (let f in aFilter) {
            rexp = new RegExp('\\\"' + f + '\\\"\:\\\"' + aFilter[f] + '\\\"');
        }

        if (rexp) {
            for (let a in this._annotations) {
                let data = this._annotations[a]._data.data;
                let x = rexp.exec(data);
                if (x) {
                    result.push(this._annotations[a].getParsedUID());
                }
            }
        }
        return result;
    }

    public getAnnotationsElements(aFilter: any): IElement[] {
        let result: IElement[] = [];
        let rexp = null;
        for (let f in aFilter) {
            rexp = new RegExp('\\\"' + f + '\\\"\:\\\"' + aFilter[f] + '\\\"');
        }

        if (rexp) {
            for (let a in this._annotations) {
                let data = this._annotations[a]._data.data;
                let x = rexp.exec(data);
                if (x) {
                    // result.push(this._annotations[a].getElement().getSceneAPIElementReference());
                    result.push(this._annotations[a].getSceneAPIElement());
                }
            }
        }
        return result;
    }

    public getJSONRepresentation(): any {
        let annotations = [];
        for (let key in this._annotations) {
            let annotation = this._annotations[key];
            annotations.push(annotation.getJSONRepresentation());
        }

        return annotations;
    }
}